import React from 'react'
import './Login.scss'
import { useLanguage } from '../Contexts/LanguageContext'

const Login = () => {
  const { language } = useLanguage();

  return (
    <div className='login-page'>
        <h1>
            {language === 'polish' ? 'login / rejestracja' : 'login / registration'}
        </h1>
        <br />
        <p>🛠️🔨⚙️ {language === 'polish' ? 'strona w budowie' : 'page under construction'} 🛠️🔨⚙️</p>
    </div>
  )
}

export default Login